import {
  Box,
} from '@mui/material'

import Layout from 'lib/components/Layout'
import LegalDocument from 'lib/components/LegalDocument'

import { TERMS } from './content'

const sectionStyles = {
  pt: 18,
  pb: 10,
}

function TermsPage() {
  return (
    <Layout>
      <Box
        id="main"
        component="section"
        sx={sectionStyles}
      >
        <LegalDocument {...TERMS} />
      </Box>
    </Layout>
  )
}

export default TermsPage
